import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { identifyMixpanelUser, resetMixpanelUser } from '../../util/mixpanel';

const MixpanelIdentity = () => {
  // console.log("Inside MixpanelIdentity");

  const currentUser = useSelector(state => state.user.currentUser);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const authInfoLoaded = useSelector(state => state.auth.authInfoLoaded);
  const identifiedUserId = useRef(null);
  const userId = currentUser?.id?.uuid;

  useEffect(() => {
    if (userId && identifiedUserId.current !== userId) {
      identifyMixpanelUser(currentUser);
      identifiedUserId.current = userId;
    } else if (authInfoLoaded && !isAuthenticated && identifiedUserId.current) {
      resetMixpanelUser();
      identifiedUserId.current = null;
    }
  }, [authInfoLoaded, currentUser, isAuthenticated, userId]);

  return null;
};

export default MixpanelIdentity;
